import { z } from "zod";

export const MaquinasEquipItensSchema = z.object({
  idItemMaquinaEquip: z.number().optional().nullable(),
  idMaquinaEquip: z.number().optional().nullable(),

  ordem: z.string(),

  descricao: z.string(),
});

export type MaquinasEquipItensForm = z.infer<typeof MaquinasEquipItensSchema>;
